// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hDt6asJGz2iL04z8DFyz {
padding: 20px;
}

.hDt6asJGz2iL04z8DFyz a {
    display: flex;
    color: var(--black);
    font-size: 12px;
    align-items: center;
}

.jTBb8vOgbjv84_ulQ6UF a {
    color: var(--black);
    display: flex;
    align-items: center;
}

.gJwgnsJwdTcI20uzgvqQ {
    margin-right: 10px;
    width: 18px;
    height: 18px;
}

.COiVgeVLb46WkOdrGhT7 {
    /*padding: 10px;*/
    display: flex;
    margin-top: 12px;
    border-radius: 5px;
    /*height: 40px;*/
    transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1), color 250ms cubic-bezier(0.4, 0, 0.2, 1);
}

._kucgXY5m1jmxAOrK8xY {
    span {
        color: var(--roman-silver);
        font-size: 10px;
    }
}

@media (max-width: 767px) {
    .hDt6asJGz2iL04z8DFyz a {
        color: var(--black);
        font-size: 12px;
    }

    ._kucgXY5m1jmxAOrK8xY {
        color: var(--black);
        display: grid;
        gap: 12px;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 1fr 1fr;

        li {
            &:first-child {
                grid-column: span 2;
            }
        }
    }

    .lUTpyBcFwtSh19RXkctZ {
        color: var(--black);
        font-size: 13px;
    }

    .COiVgeVLb46WkOdrGhT7 {
        padding: 0;
        margin-top: 0;
        height: 16px;
    }

    .hDt6asJGz2iL04z8DFyz hr {
        display: none;
    }

    .COiVgeVLb46WkOdrGhT7:hover {
        background-color: transparent;
    }

    .gJwgnsJwdTcI20uzgvqQ {
        height: 18px !important;
        width: 18px !important;
        display: inline-block;

        stroke-width: 0;
        stroke: currentColor;
        fill: currentColor;
    }
}

@media screen and (max-height: 800px) {
    ._kucgXY5m1jmxAOrK8xY {
        font-size: 13px;
    }
}

@media screen and (max-height: 720px) {
    .COiVgeVLb46WkOdrGhT7 {
        height: 28px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Contacts.module.css"],"names":[],"mappings":"AAAA;AACA,aAAa;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,yGAAyG;AAC7G;;AAEA;IACI;QACI,0BAA0B;QAC1B,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,aAAa;QACb,SAAS;QACT,8BAA8B;QAC9B,2BAA2B;;QAE3B;YACI;gBACI,mBAAmB;YACvB;QACJ;IACJ;;IAEA;QACI,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,uBAAuB;QACvB,sBAAsB;QACtB,qBAAqB;;QAErB,eAAe;QACf,oBAAoB;QACpB,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ","sourcesContent":[".contacts {\npadding: 20px;\n}\n\n.contacts a {\n    display: flex;\n    color: var(--black);\n    font-size: 12px;\n    align-items: center;\n}\n\n.pubContacts a {\n    color: var(--black);\n    display: flex;\n    align-items: center;\n}\n\n.icons {\n    margin-right: 10px;\n    width: 18px;\n    height: 18px;\n}\n\n.contactsActive {\n    /*padding: 10px;*/\n    display: flex;\n    margin-top: 12px;\n    border-radius: 5px;\n    /*height: 40px;*/\n    transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1), color 250ms cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.contactsItems {\n    span {\n        color: var(--roman-silver);\n        font-size: 10px;\n    }\n}\n\n@media (max-width: 767px) {\n    .contacts a {\n        color: var(--black);\n        font-size: 12px;\n    }\n\n    .contactsItems {\n        color: var(--black);\n        display: grid;\n        gap: 12px;\n        grid-template-columns: 1fr 1fr;\n        grid-template-rows: 1fr 1fr;\n\n        li {\n            &:first-child {\n                grid-column: span 2;\n            }\n        }\n    }\n\n    .publicContactsItems {\n        color: var(--black);\n        font-size: 13px;\n    }\n\n    .contactsActive {\n        padding: 0;\n        margin-top: 0;\n        height: 16px;\n    }\n\n    .contacts hr {\n        display: none;\n    }\n\n    .contactsActive:hover {\n        background-color: transparent;\n    }\n\n    .icons {\n        height: 18px !important;\n        width: 18px !important;\n        display: inline-block;\n\n        stroke-width: 0;\n        stroke: currentColor;\n        fill: currentColor;\n    }\n}\n\n@media screen and (max-height: 800px) {\n    .contactsItems {\n        font-size: 13px;\n    }\n}\n\n@media screen and (max-height: 720px) {\n    .contactsActive {\n        height: 28px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contacts": `hDt6asJGz2iL04z8DFyz`,
	"pubContacts": `jTBb8vOgbjv84_ulQ6UF`,
	"icons": `gJwgnsJwdTcI20uzgvqQ`,
	"contactsActive": `COiVgeVLb46WkOdrGhT7`,
	"contactsItems": `_kucgXY5m1jmxAOrK8xY`,
	"publicContactsItems": `lUTpyBcFwtSh19RXkctZ`
};
export default ___CSS_LOADER_EXPORT___;
